import React, { Component } from 'react';

import Menus from '../../modules/Menus'

import "./styles.scss"

class Dashboard extends Component {

  renderRoutes() {
    return Menus.map((menu, i) => {
      if(menu.route.name === "Dashboard") return [];
      return (
        <div 
          key={i}
          className="p-col-12 p-md-6 p-lg-3 dashboardBoxContainer"
          onClick={() => this.props.history.push(menu.route.path)} 
        >
          <div 
            className="p-grid overview-box overview-box-1 dashboardBox"
            style={{ 
              backgroundColor: menu.color,
              borderColor: menu.color,
            }}
          >
            <div className="overview-box-title">
              <i className={menu.route.icon}></i>
              <span>{menu.route.name}</span>
            </div>
            {/* <div className="overview-box-count">150</div>
            <div className="overview-box-stats">12 less than yesterday</div> */}
          </div>
        </div>
      )
    })
  }


  render() {
    return (
      <>
        <div 
          className="p-grid dashboard" >
          {this.renderRoutes()}
        </div>
      </>
    );
  }
}

export default Dashboard;
